import '../../lib/imgAreaSelect/jquery.imgareaselect.js'
import '../../lib/jquery.imageCanvasCropper.js'

(function (window, $) {

	var desiredWidth = 300;
	var desiredHeight = 55;

	window.InitCanvasCropper = function ($elem)
	{
		$elem.imageCanvasCropper({
			width: 300,
			height: 55,
			cropperHeading: "Draw a rectangle to crop the signature.",
			drawBackground: true,
			backgroundColor: '#FFF',
			hiddenInput: $elem.siblings('input[type="hidden"]').first(),
			startHidden: true
		});
	}

	function DestroyCanvasCropper($elem)
	{
		$elem.imageCanvasCropper({ remove: true });
	}

	$('input[type="file"].signature-fileupload').each(function () {
		InitCanvasCropper($(this))
	});

	$(document).on('dynamicCollectionAdded', 'li', function (e) {
		InitCanvasCropper($(e.target).find('input[type="file"].signature-fileupload'));
	});

	$(document).on('dynamicCollectionDeleted', 'li', function (e) {
		DestroyCanvasCropper($(e.target).find('input[type="file"].signature-fileupload'));
	});

})(window, jQuery);
